<template>
	<div>
		<div class="major-item" v-for="(item,index) in list" :key="index" @click="$toPage('special/'+item.id)">
			<div class="flex-betweenStart margin-bottom10">
				<div class="flex-startCenter">
					<div class="card-title font18 margin-right10" v-html="highlightText(item.name)">{{item.name}}</div>
					<div v-if="item.code" class="code">专业代码:{{item.code}}</div>
				</div>
				<div class="btn" v-if="hasBtn">开设院校</div>
			</div>
			<div class="tag" v-if="item.year">修业年限:{{item.year}}年</div>
			<div class="tag" v-if="item.degree">授予学位:{{item.degree}} </div>
			<div class="tag" v-if="item.male_rate||item.female_rate">男女比例:{{item.male_rate}}:{{item.female_rate}}
			</div>
			<div class="tag" v-if="item.compensation">平均薪酬:￥{{item.compensation}}</div>
		</div>
	</div>
</template>

<script>
	export default {
		name: 'ItemUni',
		props: {
			list: {
				type: Array,
				default () {
					return []
				}
			},
			hasBtn: {
				type: Boolean,
				default: true
			},
			keyword: {
				type: String,
				default: ''
			}
		},
		data() {
			return {

			}
		},
		methods: {
			highlightText(text) {
				if (!this.keyword || !text) return text;

				// 按空格分割关键词
				const keywords = this.keyword.trim().split(/\s+/).filter(k => k.length > 0);

				if (keywords.length === 0) return text;

				// 转义并组合正则表达式
				const escapedKeywords = keywords.map(k => k.replace(/[.*+?^${}()|[\]\\]/g, '\\$&'));
				const regex = new RegExp(`(${escapedKeywords.join('|')})`, 'gi');

				// 替换匹配的文本
				return text.replace(regex, '<span class="highlight-text">$1</span>');
			},
			toDetail(type, id) {
				this.$router.push(`/${type}/${id}`)
			}
		},
	}
</script>

<style lang="scss" scoped>
	.major-item {
		padding: 20px 0;
		cursor: pointer;

		.code {
			font-size: 12px;
			color: #666;
			height: 25px;
			display: flex;
			align-items: center;
			justify-content: center;
			padding: 0 10px;
			border-radius: 26px;
			border: 1px solid #d8d8d8;
		}

		.btn {
			width: 100px;
			height: 30px;
			border-radius: 8px;
			border: 1px solid #28b05e;
			text-align: center;
			color: #28b05e;
			display: flex;
			justify-content: center;
			align-items: center;
			font-size: 14px;
			transition: all .15s;

			&:hover {
				color: #fff;
				background-color: #28b05e;
			}
		}

		.tag {
			font-size: 14px;
			color: #666;
			display: inline-block;
			position: relative;
			margin-right: 8px;
			height: 22px;
			line-height: 22px;
			padding: 0 8px;
			border-radius: 4px;
			background: #f5f6f7;
			margin-bottom: 5px;
		}
	}
</style>
